:host {
    display: flex;
    flex-direction: row;
    font-size: var(--breadcrumb-size, 14px);
    color: var(--color-text);
    margin-bottom: 46px;
}

a {
    text-decoration: none;
    color: var(--color-text);

    &:last-child {
        color: var(--color-title-1);

        &::after {
            display: none;
        }
    }

    &:hover,
    &:focus {
        text-decoration: underline;
    }

    &.link-active {
        color: var(--color-title-1);
    }
}

span {
    margin: 0 4px;
    text-decoration: none;
}
